import { render, staticRenderFns } from "./NoticeBoardMobileCard.vue?vue&type=template&id=59181c98&scoped=true"
import script from "./NoticeBoardMobileCard.vue?vue&type=script&lang=js"
export * from "./NoticeBoardMobileCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59181c98",
  null
  
)

export default component.exports